function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default class SchemeWrapper {
  constructor(scheme) {
    _defineProperty(this, "scheme", void 0);

    this.scheme = scheme;
  }
  /** scheme type */


  get type() {
    return this.scheme.type;
  }
  /** id of this scheme */


  get id() {
    return this.scheme.id;
  }
  /** human-friendly name to refer to */


  get label() {
    return this.scheme.label;
  }
  /** more description (if any) */


  get description() {
    return this.scheme.description;
  }

}